import ContentPanel from '../../display/ui/ContentPanel';
import ScreenContainer from '../../display/ui/ScreenContainer';
import LoadDisplay from '../../display/ui/LoadDisplay';

/**
 * Displays an image in an overlay container
 * @param {Phaser.Game} game - Phaser game state
 * @param {string} imagekey - key of image to display, if a url is provided this will take priority
 * @param {string} imageurl - Url of image to display ( absolute or relative ), if a key is provided that will take priority
 */
export default class ScreenOverlayImage extends ScreenContainer {
  constructor(game, { imagekey, imageurl }) {
    super(game, { background: 'background_alt_overlay', modal: true });

    // create the content panel to display image
    this.contentPanel = new ContentPanel(this.game);
    this.contentPanel.x = this.game.defaultWidth * 0.5 - this.contentPanel.width * 0.5;
    this.contentPanel.y = this.game.defaultHeight * 0.5 - this.contentPanel.height * 0.5;
    this.addChild(this.contentPanel);

    // listen for centent close : should the close button be in here?
    this.contentPanel.onClosePanel.add(this.closePanel, this);

    // dispatch when user closes screen, will auto hide itself
    this.onScreenClosed = new Phaser.Signal();

    // so we can flag if we have loaded an image
    this.imageurl = false;

    // if image key provided, useit
    if (imagekey) {
      this.displayImage(imagekey);
    }
    // otherwise load the image
    else if (imageurl) {
      this.imageurl = imageurl;
      this.loadImage(imageurl);
    }
  }

  /*
  =======================================================================================================
    LOAD IMAGE
  =======================================================================================================
  */

  loadImage(imageurl) {
    this.imageurl = imageurl;

    // create a loader, we'll probably need this
    this.loadDisplay = new LoadDisplay(this.game, false);
    this.loadDisplay.scale.set(
      Math.min(1, (this.contentPanel.width / this.loadDisplay.width) * 0.5)
    );
    this.loadDisplay.x = this.contentPanel.width * 0.5 - this.loadDisplay.width * 0.5;
    this.loadDisplay.y = this.contentPanel.height * 0.5 - this.loadDisplay.height * 0.5;
    this.contentPanel.add(this.loadDisplay);

    // reset loader and load image
    this.game.load.baseURL = '';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.image(imageurl, imageurl, true);
    this.game.load.onFileComplete.add(this.handleImageLoaded, this);
    this.game.load.start();
  }

  handleImageLoaded() {
    this.loadDisplay.visible = false;
    // kill listener
    this.game.load.onFileComplete.remove(this.handleImageLoaded, this);
    // display the loaded image
    this.displayImage(this.imageurl);
  }

  /*
  =======================================================================================================
    DISPLAY IMAGE
  =======================================================================================================
  */

  displayImage(key) {
    console.log('displayImage super');

    if (this.image) {
      this.image.destroy(true);
    }
    // create image sprite
    this.image = this.game.make.image(0, 0, key);
    // figure out best scale for displaying the image
    const targetScale = Math.min(1, Math.min(911 / this.image.width, 550 / this.image.height));

    const targetHeight = this.image.height * targetScale;
    const targetWidth = this.image.width * targetScale;
    this.contentPanel.setSize(targetWidth, targetHeight);
    this.contentPanel.x = this.game.defaultWidth * 0.5 - this.contentPanel.width * 0.5;
    this.contentPanel.y = this.game.defaultHeight * 0.5 - this.contentPanel.height * 0.5;
    // scale and add the image
    this.image.scale.set(targetScale);
    this.contentPanel.addContent(this.image, true);
  }

  /*
  =======================================================================================================
    CLOSE
  =======================================================================================================
  */

  closePanel() {
    this.visible = false;
    this.onScreenClosed.dispatch(this);
  }

  /*
  =======================================================================================================
    DESTROY
  =======================================================================================================
  */

  destroy() {
    if (this.loadDisplay) {
      this.loadDisplay.destroy();
    }
    // destroy the image
    if (this.image) {
      this.image.destroy(true, this.imageurl != false);
      this.image = null;
    }

    // remove the load listener ( just in case )
    this.game.load.onFileComplete.remove(this.handleImageLoaded, this);

    // destroy other assets

    this.contentPanel.destroy(true);
    this.contentPanel = null;

    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/overlays/ScreenOverlayImage.js